import styled from 'styled-components';
import { getSmallIconBodyTextRules, StyledP } from '../Semantic/Semantic.styles';
export var StyledField = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledField",
  componentId: "core-12_20_2__sc-1q3pe6s-0"
})(["> ", "{", "}"], StyledP, getSmallIconBodyTextRules);
export var StyledFieldHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledFieldHeader",
  componentId: "core-12_20_2__sc-1q3pe6s-1"
})(["", " > ", "{", "}"], getSmallIconBodyTextRules, StyledP, getSmallIconBodyTextRules);
export var StyledFieldFooter = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledFieldFooter",
  componentId: "core-12_20_2__sc-1q3pe6s-2"
})(["> ", "{", "}"], StyledP, getSmallIconBodyTextRules);
//# sourceMappingURL=Field.styles.js.map